module.exports = __webpack_public_path__ + "img/dental_camera.073bb39d.jpg";